import { useFeatureFlagEnabled } from 'posthog-js/react';

/** The Microsoft Teams rollout flag; the API gates on the same key. */
export const TEAMS_FLAG = 'teams_notify_v1';

/** Whether Teams is rolled out to the org: fail closed, so the Teams card
 *  and the Teams Notify row stay hidden while the flags load. A saved Teams
 *  step still renders. */
export function useTeamsEnabled(): boolean {
  return useFeatureFlagEnabled(TEAMS_FLAG) === true;
}
